export { default } from './DOCs';
